/**
 * rsuite-table and other RSuite internals can emit a benign "ResizeObserver
 * loop" error that surfaces in the browser console and the react-scripts dev
 * error overlay. The handlers installed here swallow only that specific
 * error and leave every other error untouched.
 */

const isResizeObserverLoopError = (message?: string): boolean =>
  !!message &&
  (message.includes('ResizeObserver loop completed with undelivered') ||
    message.includes('ResizeObserver loop limit exceeded'));

/**
 * Installs window-level handlers that suppress the benign ResizeObserver
 * loop error. Call once, before the app mounts.
 */
export function installResizeObserverErrorSuppression(): void {
  window.addEventListener(
    'error',
    (event: ErrorEvent) => {
      const message: string | undefined = event.message || event.error?.message;
      if (isResizeObserverLoopError(message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  window.onerror = event => {
    const message = typeof event === 'string' ? event : '';
    return isResizeObserverLoopError(message);
  };
}
